import { useContext, useEffect } from 'react';
import UserContext from '../../User/UserSettings/UserContext';
import {
    Box, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent
} from '@mui/material';

interface StorageObject {
    id: number;
    locationName: string;
}

interface StorageSelectProps {
    isMobile: boolean;
    setSelectedStorage: (storageId: StorageObject) => void;
    selectedStorage: StorageObject;
}

function StorageSelect({ isMobile, setSelectedStorage, selectedStorage }: StorageSelectProps) {

    const { user } = useContext(UserContext) || { user: { locations: [] } };

    useEffect(() => {
        if ((!selectedStorage || selectedStorage.id === 0) && user.locations && user.locations.length > 0) {
            setSelectedStorage(user.locations[0]); // Set the full object
        }
    }, [user.locations, selectedStorage, setSelectedStorage]);

    const handleStorageChange = (event: SelectChangeEvent<number>) => {
        const selectedId = event.target.value as number;
        const newSelectedStorage = user.locations.find((loc: StorageObject) => loc.id === selectedId);
        if (newSelectedStorage) {
            setSelectedStorage(newSelectedStorage);
        }
    };

    return (<>
        <Box sx={{ flex: '1 1 250px', minWidth: 200 }}>
            <FormControl fullWidth size="small">
                <InputLabel id="storage-select-label">Storage</InputLabel>
                <Select
                    labelId="storage-select-label"
                    id="storage-select"
                    value={selectedStorage && selectedStorage.id && selectedStorage.id !== 0 ? selectedStorage.id : ''}
                    label="Storage"
                    onChange={handleStorageChange}
                    disabled={user.locations?.length === 1}
                >
                    {user.locations.map((storageObj: StorageObject) => {
                        return <MenuItem key={storageObj.id} value={storageObj.id}>
                            {storageObj.locationName}
                        </MenuItem>
                    })}
                </Select>
            </FormControl>
        </Box>
    </>)
}

export default StorageSelect;